import axios from '../request'

export interface ReportClickParams {
  // 设备类型：MP-小程序，M-移动端，PC-PC端
  device: 'MP' | 'M' | 'PC'
  // 路由路径
  route: string
  systemInfo: string
}

/**
 * 上报点击事件
 */
export function fetchReportClick(data: ReportClickParams) {
  return axios.post('/udc/save', data)
}

/**
 * 获取服务端系统时间（GMT+8，格式 yyyy-MM-dd HH:mm:ss），用于校准本地时钟
 */
export function getSystemTime(): Promise<FetchResponse<string>> {
  return axios.request({
    method: 'GET',
    url: '/config/system-time'
  })
}